/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FontColor(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FontColor',
      'aria-hidden': true,
      focusable: false,
      width:  17 * scale,
      height: 16 * scale,
      viewBox: '0 0 17 16',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M14.7 13.7 11.1 3.2H9.3L8.2 6.5c.3.8.6 1.4.7 1.9 0 0 0 .2.1.4l1-3.2c.1-.5.2-.9.2-.9s0 .4.2.9l1.4 4.1H9c0 .5-.1.9-.3 1.3h3.5l.9 2.6h-1.2V15h3.9v-1.3zm-7-1c-.8.8-1.9 1.3-3 1.3v1h3.9v-1.3H7.3z","opacity":".7"}),createElement('path', {"fill":"currentColor","d":"M1 9.5C1 11.4 2.6 13 4.5 13S8 11.4 8 9.5v-.2c0-.3-.1-.7-.1-.7C7.4 6.6 4.5 1 4.5 1S1.9 6 1.2 8.4c-.1.3-.2.7-.2 1z"}))
}
